import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
};

const AccountMarketingMaterialProfilePagePrintTemplate = ({ account }) => {
  const logoUrl = account?.logo_image?.url;
  const templateRef = useRef(null);
  const { width, height } = useComponentSize(templateRef);
  const url = `https://waldophotos.com/@${account.username}`;

  return (
    <Fragment>
      {logoUrl && (
        <div className="marketing-material-social-account-logo">
          <img
            src={logoUrl}
            alt=""
            className="marketing-material-social-account-logo-image"
          />
        </div>
      )}

      <div
        style={{
          top: `calc(55% - ${Math.round((height * 0.1 ?? 500) / 1.8)}px)`,
          right: `calc(50% - ${Math.round((width * 0.1 ?? 500) / 1.8)}px)`,
          border: `0.5vw solid #e4e4e4`,
        }}
        className="marketing-material-flyer-qrcode-secondary profile-page-qrcode"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder: {
              id: account.id,
              account,
            },
          })}
          size={width * 0.1 ?? 500}
        />
      </div>

      <p
        style={{
          fontSize: '1.25vw',
          bottom: `calc(24% - ${Math.round((height * 0.1 ?? 500) / 1.8)}px)`,
          left: 0,
          right: 0,
          margin: '0 auto',
        }}
        className="marketing-material-flyer-target-enroll-copy text-center"
      >
        <a href={url}>waldophotos.com/@{account.username}</a>
      </p>

      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_SOCIAL_PROFILE_PAGE_TEMPLATE_1.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

AccountMarketingMaterialProfilePagePrintTemplate.propTypes = propTypes;

export default AccountMarketingMaterialProfilePagePrintTemplate;
